const routes = [
  {
    path: "/Login",
    name: "login",
    component: () => import("./components/Login.vue"),
  },
  {
    path: "/Authen/Create",
    name: "create",
    component: () => import("./components/CreateAccount.vue"),
  },
  {
    path: "/Authen/Forget",
    name: "Forget",
    component: () => import("./components/ForgetAccount.vue"),
  },

];
export default routes;
